import api from '@/services/APIService';

class SeriesRaceService {
    /**
     * Saves or updates a race.
     *
     * @param {Object} data - The race data to save.
     * @returns {Promise} - The promise with the API response.
     */
    saveRace(data) {
        return api.fetch({ method: 'post', path: 'promoter/series/table/race', data });
    }

    /**
     * Fetches the list of races for selection input.
     * @returns {Promise} - The list of race items or error.
     */
    async getRacesSelect() {
        return await api.fetch({ method: 'get', path: 'promoter/series/races-select' });
    }
}

export default new SeriesRaceService();
